import { Avatar } from 'antd'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import React, { useEffect, useMemo } from 'react'
import { getCurrentMarket, getNameInitials, setCurrentMarket } from '@utils/general'
import { useUserSettings } from '@hooks/settings'

export const UserSummary = ({ scopes, isMobile }) => {
  const { updateSetting } = useUserSettings()
  let currentMarket = getCurrentMarket() || ''
  const { user, getUser } = useSecurityContext()
  const name = useMemo(() => {
    if (!user)
      getUser().then((res) => {
        return res?.username || res?.full_name
      })
    return user?.full_name || user?.username
  }, [user])

  useEffect(() => {
    if (scopes && scopes.market_names?.length && !scopes.market_names?.includes(currentMarket)) {
      setCurrentMarket(scopes.market_names[0])
      currentMarket = scopes.market_names[0]
      updateSetting('currentMarket', scopes.market_names[0]).then()
    }
  }, [scopes?.market_names, currentMarket])

  return (
    <Horizontal className={`${isMobile ? '' : 'ml-4'}`}>
      <div className='vertical-flex pr-2'>
        {!isMobile && (
          <>
            <Texto align='right' category='p2' weight='bold'>
              {name}
            </Texto>
            <Texto align='right' category='label'>
              {currentMarket || 'All Markets'}
            </Texto>
          </>
        )}
      </div>
      <div className='vertical-flex-center pl-3'>
        <Avatar shape='square' style={{ borderRadius: 5, background: 'var(--primary-gradient)' }} size={36}>
          {name && getNameInitials(name)}
        </Avatar>
      </div>
    </Horizontal>
  )
}
